"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BronsonSelector = void 0;
const React = require("react");
const BronsonSelector = ({ items, method, }) => {
    if (!items.length) {
        return (React.createElement("p", { className: 'c-compare-and-select__description u-pb-large' }, "No options to show"));
    }
    const [checked, setChecked] = React.useState(items[0].id);
    const selectorItems = items.map((item, index) => {
        const subtitle = item.subtitle ? (React.createElement("p", { id: `dh-bronson-selector-subtitle-${index}`, className: 'c-compare-and-select__description' }, item.subtitle)) : (React.createElement(React.Fragment, null));
        const onChangeHandler = (itemId) => {
            setChecked(itemId);
            method(itemId);
        };
        return (React.createElement("div", { className: 'c-compare-and-select__item  js-compare-and-select__item o-layout__item  u-1/2 u-1/1@s', key: index },
            React.createElement("input", { className: 'c-compare-and-select__hidden-input', type: 'radio', name: 'compare-and-select-input', id: item.id, onChange: () => onChangeHandler(item.id), defaultChecked: checked === item.id }),
            React.createElement("div", { className: 'c-compare-and-select u-pt-large u-m-none' },
                React.createElement("label", { htmlFor: item.id, className: 'label-compare-and-select u-text-center u-ph-small' },
                    React.createElement("header", { className: 'c-compare-and-select__title' },
                        React.createElement("h4", { className: 'c-compare-and-select__title-text u-text-center', title: 'Regular Product' },
                            React.createElement("b", null, item.title))),
                    subtitle,
                    React.createElement("p", { id: `dh-bronson-selector-desc-${index}`, className: 'c-compare-and-select__description u-pb-large' }, item.description)))));
    });
    return (React.createElement("div", { className: 'c-compare-and-select-container' },
        React.createElement("div", { className: 'o-layout o-layout--equal-height' }, selectorItems)));
};
exports.BronsonSelector = BronsonSelector;
